module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper fadeInDown"
  }, [_c('Toast', {
    staticStyle: {
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "formContentReg"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h1', {
    staticClass: "active",
    staticStyle: {
      "margin-bottom": "-1px",
      "margin-left": "-52%"
    }
  }, [_vm._v("  Sell Like Cheetah\n               ")]), _vm._v(" "), _c('br', {
    staticStyle: {
      "margin-bottom": "-1px"
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "active"
  }, [_vm._v("\n                 Science behind rapid Sales Closing\n                 ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "active",
    staticStyle: {
      "margin": "2px 8px 10px 8px",
      "border-bottom": "0px solid #5fbae9"
    }
  }, [_vm._v(" & ")]), _vm._v(" "), _c('br', {
    staticStyle: {
      "margin-bottom": "-1px"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "active",
    staticStyle: {
      "margin-bottom": "-1px"
    }
  }, [_vm._v("Get Connected\n                 ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h6', {
    staticClass: "active",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._v("\n                 Science of reaching more people to sell\n                 ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "active"
  }, [_vm._v(" ५ जेठ २०७८ बुधवार, May 19, 2021 (Wednesday) 6 PM ")]), _vm._v(" "), _c('h1', {
    staticClass: "active"
  }, [_vm._v("Registration charges NPR 300/-\n                 ")]), _vm._v(" "), _c('h3', {
    staticClass: "active"
  }, [_vm._v(" Registration ")]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "wrap-input1 validate-input",
    attrs: {
      "data-validate": "Name is required"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "fadeIn ",
    attrs: {
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "shadow-input1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-input1 validate-input",
    attrs: {
      "data-validate": "Valid email is required: ex@abc.xyz"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input1",
    attrs: {
      "type": "text",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "shadow-input1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-input1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "input1",
    attrs: {
      "type": "text",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "shadow-input1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-input1 validate-input",
    attrs: {
      "data-validate": "Mobile number is required: 9800xxx"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "input1",
    attrs: {
      "type": "text",
      "placeholder": "Mobile number"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "shadow-input1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-input1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymentDetails),
      expression: "paymentDetails"
    }],
    staticClass: "input1",
    attrs: {
      "type": "text",
      "placeholder": "Payment Details"
    },
    domProps: {
      "value": (_vm.paymentDetails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paymentDetails = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "shadow-input1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-input1 validate-input",
    attrs: {
      "data-validate": "Message is required"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.feedback),
      expression: "feedback"
    }],
    staticClass: "input1",
    attrs: {
      "placeholder": "Have you joined Mr. Lekh Nath Poudel's training before? If yes! Feedback please."
    },
    domProps: {
      "value": (_vm.feedback)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.feedback = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "shadow-input1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-input1 validate-input",
    attrs: {
      "data-validate": "Message is required"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "input1",
    attrs: {
      "placeholder": "Why you want to join this session?"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "shadow-input1"
  })]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "container-contact1-form-btn"
  }, [_c('button', {
    staticClass: "contact1-form-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sendInquiry.apply(null, arguments)
      }
    }
  }, [_vm._m(4)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "left",
      "margin": "4px -406px 0px -306px"
    }
  }, [_c('span', {
    staticClass: "underlineHover"
  }, [_vm._v("Supported by:")]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "https://kathmandu.bachpanglobal.in/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "src": "https://bestdataprovider.com/wp-content/uploads/Bachpan-A-Play-School-Bachpan.png",
      "alt": "Bachpan"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "left",
      "margin": "14px 0px -40px -40px"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "https://rishihood.edu.in/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "23%"
    },
    attrs: {
      "src": "/static/img/rishihood.jpg",
      "alt": "Rishihood"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "margin": "-4% -9% -24% 71%"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/Trainer-LNP-109487184253506/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "38%"
    },
    attrs: {
      "src": "/static/img/lnp.jpg",
      "alt": "LNP"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap-input1 validate-input"
  }, [_c('span', {
    staticClass: "underlineHover"
  }, [_vm._v("For Payment Please Click.")]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "/static/img/payment.jpg",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "src": "/static/img/pay.jpg",
      "alt": "Payment"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("\n                              Register\n                              "), _c('i', {
    staticClass: "fa fa-long-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-041cbd65"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/eventManagement/registerEvent.vue
// module id = 2010
// module chunks = 0